<template>
  <div>    <div class="form-group row">
      <div class="col-sm-2">
        <label>Tipo: </label>
      </div>
      <div class="col-sm-10 p-0">
        <select class="form-control center-select" v-model="filtroInteressado.tipoInteressado" @change="ocultarCampos">
          <option v-for="(item, indice) in tipoInteressados" :key="indice" :value="item.key">{{ item.value }}</option>
        </select>
      </div>
    </div>
    <div class="form-group row mt-3">
      <div class="col-md-2">
        <label>Nome:</label>
      </div>
      <div class="col-md-4 col-sm-10 mb-3 p-0">
        <input type="text" class="form-control" v-model="filtroInteressado.nome">
      </div>

      <div v-if="isPessoaFisica !== ''" class="col-md-2">
        <label v-show="isPessoaFisica == 'true'">CPF:</label>
        <label v-show="isPessoaFisica == 'false'">CNPJ:</label>
      </div>
      <div v-if="isPessoaFisica !== ''" class="col-md-4 col-sm-10 mb-3 p-0">
        <the-mask v-show="isPessoaFisica == 'true'" :mask="['###.###.###-##']" type="text" class="form-control" v-model="filtroInteressado.cpf" />
        <the-mask v-show="isPessoaFisica == 'false'" :mask="['##.###.###/####-##']" type="text" class="form-control" v-model="filtroInteressado.cnpj" />
      </div>

      <div class="row acoes">
        <button class="btn btn-outline-success" @click.prevent="pesquisar"> Pesquisar </button>
        <button class="btn btn-outline-danger" @click.prevent="limpar"> Limpar </button>
      </div>
    </div>
  </div>
</template>

<script>
import InteressadoService from '@/services/InteressadoService'
import eventBus from '@/uteis/eventBus'

export default {
  name: 'filtroPesquisa',

  props: {
    rowsNumber: { required: true, type: Number },
    eventBusDataName: { required: true, type: String },
    eventBusPaginationName: { required: true, type: String }
  },

  data () {
    return {
      filtroInteressado: {
        tipoInteressado: 'PESSOAFISICA',
        cpf: '',
        Cnpj: '',
        nome: '',
        offset: 1,
        range: this.rowsNumber,
        idDepartamento: ''
      },
      isPessoaFisica: 'true',
      tipoInteressados: [
        {
          key: 'PESSOAFISICA',
          value: 'Pessoa Física'
        },
        {
          key: 'PESSOAJURIDICA',
          value: 'Pessoa Juridica'
        }
      ]
    }
  },

  created () {
    eventBus.$on(this.eventBusPaginationName, (numeroPagina) => {
      this.trocaDePagina(numeroPagina)
    })

    this.interessadoService = new InteressadoService()
    this.consultar()
  },

  methods: {
    pesquisar () {
      this.filtroInteressado.offset = 1
      this.consultar()
    },

    consultar () {
      const dadosSessao = this.$store.getters.getDadosSessao
      this.filtroInteressado.idDepartamento = dadosSessao.sessao.idDepartamento

      if (this.filtroInteressado.tipoInteressado === 'TODOS') {
        this.filtroInteressado.tipoInteressado = ''
      }

      this.interessadoService.consultarInteressado(this.filtroInteressado).then(res => {
        eventBus.$emit(this.eventBusDataName, res.data)

        if (this.filtroInteressado.tipoInteressado === '') {
          this.filtroInteressado.tipoInteressado = 'TODOS'
        }
      }).catch(err => {
        console.log(err)
      })
    },

    limpar () {
      this.filtroInteressado.cpf = ''
      this.filtroInteressado.cnpj = ''
      this.filtroInteressado.nome = ''
      this.consultar()
      this.ocultarCampos()
    },

    trocaDePagina (numeroPagina) {
      this.filtroInteressado.offset = numeroPagina
      this.consultar()
    },

    ocultarCampos () {
      if (this.filtroInteressado.tipoInteressado === 'PESSOAFISICA') {
        this.isPessoaFisica = 'true'
        this.filtroInteressado.cnpj = ''
      } else if (this.filtroInteressado.tipoInteressado === 'PESSOAJURIDICA') {
        this.isPessoaFisica = 'false'
        this.filtroInteressado.cpf = ''
      } else {
        this.isPessoaFisica = ''
        this.filtroInteressado.cpf = ''
        this.filtroInteressado.cnpj = ''
      }
    }
  },

  destroyed () {
    eventBus.$off(this.eventBusPaginationName)
  }
}
</script>

<style scoped lang="scss">

.row {
  margin-top: 2px;
}

.acoes {
  padding: 5px;

  .btn {
    margin-right: 10px;
    width: 150px;
    height: 28px;
  }
}
</style>
